<template>
  <div>
    <b-field
      label="ログイン種別の選択">
      <div id="firebaseui-auth-container" />
    </b-field>
  </div>
</template>

<script>
// TODO: plugins/firebase.js からだと使えないです。
import firebase from 'firebase';

//NOTE: Veturに怒られていますが、こうしないと動きません。
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css'

export default {
  name: 'AuthProviderSelector',
  mounted() {
    const uiconfig = {
      callbacks: {
        signInSuccessWithAuthResult: (authResult) => {
          this.$emit('sign-in-success-event', {
            authResult: authResult
          })
        },
        signInFailure: () => {
          alert('sign in failure');
        }
      },
      signInFlow: 'popup',
      signInOptions: [
        { // https://github.com/firebase/firebaseui-web#configure-email-provider
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: false,
        }, 
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      ],
    }
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    ui.start('#firebaseui-auth-container', uiconfig);
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/signup-email.scss';
</style>
